export const getRegexrForVat = () => /^(\w|\d|\s|[\\/+-]){8,20}$/;

export const getRegexrForAcronym = () => /^\w{1,10}$/;

export const getRegexrForPhoneNumber = (country = 'AO') => {
    switch (country) {
        case 'AO':
            return /^(\(?\+?244\)?)?( |-)?(\d{9}|\d{3}(( |-)?\d{3}){2}|\d{3}(( |-)?\d{2}){3})$/;
        case 'PT':
            return /^(\(?\+?351\)?)?( |-)?(\d{9}\d{3}(( |-)?\d{3}){2}|\d{3}(( |-)?\d{2}){3})$/;
        case 'BR':
            return /^(\(?\+?55\)?)?( |-)?(\d{10}|\d{2}(( |-)?\d{4}){2}|\d{2}(( |-)?\d{2}){4})$/;
        case 'CU':
            return /^(\(?\+?53\)?)?(( |-)?\d{8}|(( |-)?\d{2}){4}|( |-)?\d{1}(( |-)?\d{7}|( |-)?\d{3}( |-)?\d{4}|( |-)?\d{3}(( |-)?\d{2}){2}))$/;
        default:
            return /^\+?\d{1,3}(( |-)?\d+){2,8}$/;
    }
};

export const isIRI = (text) => new RegExp(/^\/\w+\/\w+\/\d+$/).test(text);
